import { DropDownList, MultiSelect } from '@progress/kendo-react-dropdowns';
import { FieldRenderProps, FieldWrapper } from '@progress/kendo-react-form';
import { Label } from "@progress/kendo-react-labels";
import React, { FunctionComponent, useState } from 'react'
import { ClientApi } from '../../../redux/api/ClientApi';

const ClientList: FunctionComponent<FieldRenderProps> = props => {
    const {
        validationMessage,
        touched,
        label,
        id,
        valid,
        disabled,
        hint,
        type,
        optional,
        value,
        data,
        multiSelect,
        clientIds,
        clientTypeId,
        ...others
    } = props;
    //const values = Array.isArray(field?.VALUES) ? field?.VALUES?.map(v => toInteger(v)) : [];
    const [opened, setOpened] = useState(false);
    const { data: clients } = ClientApi.useGetClientListQuery(clientTypeId);
    const currentValues = clientIds?.length > 0 ? clients?.filter(i => clientIds?.indexOf(i.ID) > -1) : undefined;
    const fieldChanged = (e) => {
        props.onChange(e);
    }
    const multiFieldChanged = (e) => {
        props.onChange(e);
    }

    return (
        <>
            <Label
                editorId={id}
                editorValid={valid}
                editorDisabled={disabled}
                optional={optional}
            >
                {label}
            </Label>
            {
                multiSelect
                    ? <MultiSelect {...others} popupSettings={{ className: "z500" }} placeholder='Select multiple' onChange={multiFieldChanged} value={currentValues} data={clients} textField="Company_Name" dataItemKey='ID'
                        opened={opened}
                        onFocus={() => { setOpened(true) }}
                        onBlur={() => { setOpened(false) }} />
                    : <DropDownList {...others} popupSettings={{ className: "z500" }} defaultItem={{ Company_Name: "Select" }} onChange={fieldChanged} value={currentValues?.length > 0 ? currentValues[0] : undefined} data={clients} dataItemKey="ID" textField="Company_Name" />
            }
        </>
    )
}

export default ClientList;